module.exports = __webpack_public_path__ + "img/or_logo_footer.f2dc7d95.png";